import { SELECTABLE_COLUMN_WIDTH } from '@aibees/shared/features/advance-table/constant';
import type { SxStyle } from '@aibees/shared/theme';
import { Box, TableCell, TableHead, TableRow, useTheme } from '@mui/material';
import * as SX from './sx';
import TableHeadCol from './table-head-col';
import type { TableColumn } from './types';

type Props = {
  order?: 'asc' | 'desc';
  orderBy?: string;
  headLabel: TableColumn[];
  sx?: SxStyle;
  cellSx?: SxStyle;
  canSelectAllRows?: boolean;
  onSort?: (id: string) => void;
};

export default function TableHeadCustom({
  order,
  orderBy,
  headLabel,
  sx,
  cellSx,
  canSelectAllRows,
  onSort,
}: Props) {
  const theme = useTheme();
  const hasStickyCol = headLabel.some((i) => i.isSticky);

  return (
    <TableHead sx={sx}>
      <TableRow sx={SX.tableHeaderRow} className="TableHeaderRow">
        {canSelectAllRows && (
          <TableCell
            className="TableRowSelectCell"
            padding="checkbox"
            sx={{
              ...(hasStickyCol && {
                position: 'sticky',
                pl: 0,
                left: 0,
                zIndex: 99,
              }),
              ...cellSx,
              background: theme.palette.grey[100],
            }}
          >
            <Box sx={SX.tableRowSelectCellInnerBox} />
          </TableCell>
        )}

        {headLabel.map((headCell, index) => (
          <TableHeadCol
            colSpan={canSelectAllRows === false && index === 0 ? 2 : 1}
            key={headCell.key || headCell.id}
            isLast={index === headLabel.length - 1}
            headCell={headCell}
            order={order}
            orderBy={orderBy}
            onSort={onSort}
            sx={
              headCell.isSticky
                ? {
                    position: 'sticky',
                    left: SELECTABLE_COLUMN_WIDTH,
                    zIndex: 100,
                  }
                : { borderRight: 'solid 1px red' }
            }
          />
        ))}
      </TableRow>
    </TableHead>
  );
}
